<template>
  <div>   
  <my-request-layout
    :workflowGuid="registration.workflowGuid"
    :foundRequest="!!registration"
    :isLoading="isLoading"
    :myRequest="registration"
    :cancelRequest="cancelRequest"
    :paymentStatus="paymentStatus"

    useAuthorizedPayment
    :makePayment="makePayment"
    :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
  >
    <span slot="title"
      >Litter whelped on
      <span
        v-if="!!registration"
        :class="registration.isWhelpingDateConflicting ? 'red--text' : ''"
      >
        {{ $dateUtils.formatDate(registration.whelpingDate) }}
      </span>
      <v-alert
        class="mb-2 mt-1"
        v-if="!!registration && !registration.dnaVerified"
        type='warning'
        >      
          <span v-html="parentDnaVerifiedWarning"></span>&nbsp;
          <span v-html="geneticTestingLink"></span>
      </v-alert>
      <v-alert v-if="!!registration && registration.isArtificialInsemination" type="warning">
          Sire’s collection information and <span v-html="artificialInseminationLink" /> must be on file with ASCA prior to approval of the litter.
          Please send semen collection documentation from collection facility as well as AI forms directly to <span v-html="registrarEmailLink" />.
      </v-alert>
    </span>    
    <div slot="requestContent" v-if="!!registration && registration.puppies">   
      <litter-registration-request :registration="registration">
      </litter-registration-request>
    </div>
  </my-request-layout>
  <v-snackbar v-model="showErrorMessage" title color="error">
    {{ errorMessage }}
    <template v-slot:action="{ attrs }">
    <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
      Close
    </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import LitterRegistrationRequest from "@/components/Portal/MyRequest/LitterRegistrationRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

import { LitterRegistration } from "@/constants";

export default Vue.extend({
  name: "MyLitterRegistrationRequest",
  components: {
    MyRequestLayout,
    LitterRegistrationRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
      parentDnaVerifiedWarning: LitterRegistration.MissingDNA_Parents,    
      geneticTestingLink: LitterRegistration.GeneticTesting_Link,
      artificialInseminationLink: LitterRegistration.ArtificialInsemination_Link,
      registrarEmailLink: LitterRegistration.RegistrarEmail_Link,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getLitterRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData | null) {
      var req = {
        paymentInfo,
        personId: this.userInfo.personId,
        workflowGuid: this.registration.workflowGuid,
      };

      workflowService.submitLitterCCPayment(req).then((res) => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
